import React from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import CustomEmailSettingsPage from "../CustomEmail";
import EmailTemplatesSettingsPage from "../EmailTemplates";

const EmailSettingsPage = () => {
  const location = useLocation();
  const history = useHistory();
  const { url } = useRouteMatch();

  const pathParts = location.pathname.split("/");
  const lastPathPart = pathParts[pathParts.length - 1];
  const activeTab =
    lastPathPart === "email" ? "email" : lastPathPart || "email";

  const handleTabSelect = (key) => {
    history.push(key === "email" ? url : `${url}/${key}`);
  };

  return (
    <>
      <Row>
        <Col>
          <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
            <Tab title="E-Mail Einstellungen" eventKey={"email"}>
              {activeTab === "email" && <CustomEmailSettingsPage />}
            </Tab>
            <Tab title="E-Mail-Vorlagen" eventKey={"email-templates"}>
              {activeTab === "email-templates" && (
                <EmailTemplatesSettingsPage />
              )}
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </>
  );
};

export default EmailSettingsPage;
